import { render, staticRenderFns } from "./AdminSearch.vue?vue&type=template&id=c1950f12"
import script from "./AdminSearch.vue?vue&type=script&lang=js"
export * from "./AdminSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports